import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApi } from "@/lib/api";
import { PageTitle } from "@/components/Bits";

const NUMS = [
  ["max_duration_minutes", "Max interview duration (minutes)"],
  ["target_questions", "Target number of officer questions"],
  ["pass_threshold", "Pass threshold score (0-100)"],
];

export default function AdminSettings() {
  const api = useApi();
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api("get", "/admin/settings").then(setS); }, [api]);

  const save = async () => {
    setSaving(true);
    try {
      setS(await api("put", "/admin/settings", { ...s, max_duration_minutes: +s.max_duration_minutes, target_questions: +s.target_questions, pass_threshold: +s.pass_threshold }));
      toast.success("Settings saved");
    } catch { toast.error("Could not save settings"); }
    setSaving(false);
  };

  if (!s) return null;
  return (
    <div className="fade-up max-w-4xl" data-testid="admin-settings-page">
      <PageTitle kicker="Super admin" title="Officer & assessor settings" />
      <Label className="font-mono text-xs tracking-[0.2em] uppercase text-slate-400">Additional information / instructions</Label>
      <p className="text-sm text-slate-500 mt-2">Given to Officer Fredo Quist during interviews and to the AI assessor during evaluation (company background, SOP principles, special instructions).</p>
      <Textarea value={s.additional_info} onChange={(e) => setS({ ...s, additional_info: e.target.value })} rows={14}
        className="mt-3 bg-slate-900 border-slate-800 font-mono text-sm" data-testid="settings-additional-info" />
      <div className="grid md:grid-cols-3 gap-6 mt-8">
        {NUMS.map(([k, label]) => (
          <div key={k}>
            <Label className="text-xs text-slate-400">{label}</Label>
            <Input type="number" value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="mt-2 bg-slate-900 border-slate-800" data-testid={`settings-${k}`} />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="settings-save-btn" className="mt-10 bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white px-8 py-3 transition-colors">
        {saving ? "Saving..." : "Save settings"}
      </button>
    </div>
  );
}
